export default __webpack_public_path__ + "static/media/nexus.759aaf06.png";